import { reactive } from 'vue';

const eventBus = reactive({});

eventBus.on = (event, callback) => {
  if (!eventBus[event]) {
    eventBus[event] = [];
  }
  eventBus[event].push(callback);
};

eventBus.off = (event, callback) => {
  if (!eventBus[event]) return;
  if (!callback) {
    delete eventBus[event];
    return;
  }
  eventBus[event] = eventBus[event].filter(listener => listener !== callback);
  if (!eventBus[event].length) delete eventBus[event];
};

eventBus.emit = (event, ...args) => {
  if (eventBus[event]) {
    [...eventBus[event]].forEach(callback => callback(...args));
  }
};

export default eventBus;
